import axios from "axios"
import Buefy from "buefy"
import Vue from "vue"
import VueRouter from "vue-router"
import App from "./App.vue"
import "./filters"
import "./filters.js"
import AppRouter from "./AppRouter"
import Environment from "./services/Environment.js"
import { store } from "./store"
import "./validate"
import { UsuarioService } from "./rest"

// Axios -------------------------------------------------------------------------------

axios.defaults.baseURL = `${Environment.url}`
axios.interceptors.request.use(
    function (config) {
        store.dispatch("AppStore/_loadingOn")
        const usuario = UsuarioService.getUsuario()
        if (usuario) {
            config.headers.common.Authorization = `Bearer ${usuario.token}`
            config.headers.common.User = usuario.usu_id
        } else {
            config.headers.common.Authorization = ""
            config.headers.common.User = ""
        }
        return config
    },
    function (error) {
        store.dispatch("AppStore/_loadingOff")
        return Promise.reject(error)
    }
)
axios.interceptors.response.use(
    function (response) {
        store.dispatch("AppStore/_loadingOff")
        return response
    },
    function (error) {
        store.dispatch("AppStore/_loadingOff")
        return Promise.reject(error)
    }
)

// Vue -------------------------------------------------------------------------------

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Buefy, {
    defaultToastDuration: 3500
})

new Vue({
    router: AppRouter,
    store,
    render: h => h(App)
}).$mount("#app")
